import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Empty, ErrorBox, PageHead } from "../components/Bits";
import { Badge, Card, Select, Table } from "../design-system/components";
import { endpoints } from "../lib/api";
import { formatDateTime } from "../lib/format";
import { useSession } from "../lib/session";

export function LeaderboardPage() {
  const { user } = useSession();
  const [seasonId, setSeasonId] = useState("");
  const board = useQuery({
    queryKey: ["leaderboard", seasonId],
    queryFn: () => endpoints.leaderboard(seasonId || undefined),
  });
  if (board.error) return <ErrorBox error={board.error} />;
  const entries = board.data?.entries ?? [];
  const seasons = board.data?.seasons ?? [];
  return (
    <div className="rk-stack">
      <PageHead
        title="Leaderboard"
        subtitle="Competitive Elo from each player's most recent TCG Live log. Only players with a reported Elo appear."
      />
      <div className="pr-inline">
        <div style={{ width: 260 }}>
          <Select
            size="sm"
            value={seasonId}
            onChange={setSeasonId}
            options={[
              { value: "", label: "Latest Elo (any season)" },
              ...seasons.map((s) => ({ value: s.seasonId, label: s.name })),
            ]}
          />
        </div>
      </div>
      <Card flush>
        {entries.length === 0 ? (
          <Empty title="No Elo reported yet">
            <p>Elo appears once a log with the [CompetitiveElo] line is uploaded.</p>
          </Empty>
        ) : (
          <Table>
            <thead>
              <tr>
                <th className="num">#</th>
                <th>Player</th>
                <th className="num">Elo</th>
                <th>Season</th>
                <th className="num">Games</th>
                <th>As of</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e, i) => (
                <tr
                  key={e.userId}
                  style={
                    e.userId === user?.userId
                      ? { background: "color-mix(in srgb, var(--primary) 8%, transparent)" }
                      : undefined
                  }
                >
                  <td className="num">{i + 1}</td>
                  <td>
                    {e.hasHandle ? e.name : <span className="pr-mono pr-muted">{e.name}</span>}{" "}
                    {e.userId === user?.userId && <Badge variant="accent">you</Badge>}
                  </td>
                  <td className="num" style={{ fontWeight: 700 }}>
                    {e.elo}
                  </td>
                  <td>{e.seasonName ?? e.seasonId}</td>
                  <td className="num">{e.gamesCount}</td>
                  <td className="pr-muted">{formatDateTime(e.at)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card>
    </div>
  );
}
